"use client";

import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "@repo/design-system/components/ui/skeleton";
import { filterTypes as by } from "@repo/design-system/types/filter";
import dynamic from "next/dynamic";
import { ClearFilters } from "~/components/job-board/filterbar/clear-filters";
import { MultiSelect } from "~/components/job-board/filterbar/filters/multi-select";
import { SearchbarHungary } from "~/components/job-board/filterbar/searchbar-eon-hungary";
import { ToggleMap } from "~/components/job-board/filterbar/toggle-map-eon";
import { NewsletterFilterbarEonHungary } from "~/components/job-board/newsletter/newsletter-filterbar-eon-hungary";
import { NewsletterModal } from "~/components/job-board/newsletter/newsletter-modal-eon";
import JobAdVideo from "~/components/job-page/jobadvideo/jobad-video-eon";
import { useLanguage } from "~/translations/loader/use-language";
const WatchJobs = dynamic(() => import("~/components/job-board/filterbar/watch-jobs-eon").then(m => m.WatchJobs), {
  ssr: false,
  loading: () => <Skeleton className="h-12" />
});
export default function FilterbarHungary() {
  const $ = _c(25);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 h-full w-full overflow-hidden"><JobAdVideo className="h-full w-full [&>div]:aspect-auto [&>div]:h-full [&_video]:object-cover [&_video]:object-top" hideControls={true} loop={true} muted={true} playOnLoad={true} videoUrl="hungary/headerVideo720.mp4" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.filterbar_tagline_hungary) {
    t1 = <div><h1 className="font-bold text-5xl md:mb-2">{t.filterbar_tagline_hungary}</h1></div>;
    $[1] = t.filterbar_tagline_hungary;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t.aria_header_filterbar) {
    t2 = <h2 className="sr-only">{t.aria_header_filterbar}</h2>;
    $[3] = t.aria_header_filterbar;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SearchbarHungary />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [by.JOB_FIELD];
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t.filterbar_filter4_placeholder) {
    t5 = <MultiSelect filterBy={t4} id="1" label={t.filterbar_filter4_placeholder} />;
    $[7] = t.filterbar_filter4_placeholder;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [by.ENTRY_LEVEL_MULTI];
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t.filterbar_filter2_placeholder) {
    t7 = <MultiSelect filterBy={t6} id="2" label={t.filterbar_filter2_placeholder} />;
    $[10] = t.filterbar_filter2_placeholder;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [by.LOCATION_CITY];
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t.filterbar_filter1_placeholder) {
    t9 = <MultiSelect filterBy={t8} id="6" label={t.filterbar_filter1_placeholder} />;
    $[13] = t.filterbar_filter1_placeholder;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <WatchJobs buttonVariant="default" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t5 || $[17] !== t7 || $[18] !== t9) {
    t11 = <div className="z-20 grid grid-flow-row items-center gap-4 text-lg md:grid-cols-2 xl:grid-cols-4">{t5}{t7}{t9}{t10}</div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="relative z-10 grid grid-cols-1 gap-4 text-lg md:grid-cols-2 xl:grid-cols-4"><ToggleMap className="hover:border-transparent" variant="default" /><NewsletterModal className="hover:border-transparent" filterbarComponent={NewsletterFilterbarEonHungary} variant="default" /><ClearFilters className="md:col-start-2 xl:col-span-2" /></div>;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t1 || $[22] !== t11 || $[23] !== t2) {
    t13 = <section className="relative flex min-h-[500px] w-full items-end justify-center bg-primary px-6 py-6 text-white md:px-10 md:py-20" id="filterbar" tabIndex={-1}>{t0}<div className="relative z-10 mt-auto grid h-fit w-full max-w-screen-xl gap-y-4">{t1}{t2}{t3}{t11}{t12}</div></section>;
    $[21] = t1;
    $[22] = t11;
    $[23] = t2;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
}